import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetBranchModel } from "@factory/model/query-model-branch";
import { branchFormDefault } from "./form.default";
import { BranchFormSchema } from "./form.rule";

export const useFormDefaultBranch = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetBranchModel | undefined) => {
    return !cachedValue
      ? branchFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
        head: cachedValue.head,
        tenant: cachedValue.tenant,
      } as BranchFormSchema);
  };

  return {
    getDefault,
  };
};
